import { Contract } from "@edp-components/edp-contract";
import { Card } from "@edp-models/benefits.model";
import { ComparatorEfficientHouse, ComparatorElectricMobility, ContractEfficiency, ContractPsData } from "@edp-models/energy-efficiency.model";
import { Action } from "@ngrx/store";


export enum EEnergyEfficiencyActions {
    GetContractEfficiency   = "[EnergyEfficiency] Get selected Contract Efficiency",
    SetContractEfficiency   = "[EnergyEfficiency] Set selected Contract Efficiency",
    GetProductServiceCardData  = "[EnergyEfficiency] Get Products and Service card data",
    SetProductServiceCardData  = "[EnergyEfficiency] Set Products and Service card data",
    GetContentCardData = "[EnergyEfficiency] Get Content card data",
    SetContentCardData = "[EnergyEfficiency] Set Content card data",
    GetComparatorEfficientHouse = "[GetComparatorEfficientHouse] Get Comparator Efficient House",
    SetComparatorEfficientHouse = "[SetComparatorEfficientHouse] Set Comparator Efficient House",
    GetComparatorElectricMobility = "[GetComparatorElectricMobility] Get Comparator Electric Mobility",
    SetComparatorElectricMobility = "[SetComparatorElectricMobility] Set Comparator Electric Mobility"
}


export class GetContractEfficiency implements Action {
    public readonly type = EEnergyEfficiencyActions.GetContractEfficiency;
    constructor(public contract: Contract) {
    }
}

export class SetContractEfficiency implements Action {
    public readonly type = EEnergyEfficiencyActions.SetContractEfficiency;
    constructor(public contractEfficiency: ContractEfficiency) {}
}

export class GetProductServiceCardData implements Action {
    public readonly type = EEnergyEfficiencyActions.GetProductServiceCardData;
    constructor() {}
}

export class SetPsData implements Action {
    public readonly type = EEnergyEfficiencyActions.SetProductServiceCardData;
    constructor(public psData: ContractPsData[]) {}
}

export class GetContentCardData implements Action {
    public readonly type = EEnergyEfficiencyActions.GetContentCardData;
    constructor(public contract: Contract) {}
}

export class SetContentCardData implements Action {
    public readonly type = EEnergyEfficiencyActions.SetContentCardData;
    constructor(public contentCardData: Card[]) {}
}

export class GetComparatorEfficientHouse implements Action {
    public readonly type = EEnergyEfficiencyActions.GetComparatorEfficientHouse;
    constructor(public contract: Contract) {}
}

export class SetComparatorEfficientHouse implements Action {
    public readonly type = EEnergyEfficiencyActions.SetComparatorEfficientHouse;
    constructor(public payload: ComparatorEfficientHouse | null) {}
}

export class GetComparatorElectricMobility implements Action {
    public readonly type = EEnergyEfficiencyActions.GetComparatorElectricMobility;
    constructor(public contract: Contract) {}
}

export class SetComparatorElectricMobility implements Action {
    public readonly type = EEnergyEfficiencyActions.SetComparatorElectricMobility;
    constructor(public payload: ComparatorElectricMobility | null) {}
}

export type EnergyEfficiencyActions =
    | GetContractEfficiency
    | SetContractEfficiency
    | GetProductServiceCardData
    | SetPsData
    | SetContentCardData
    | GetContentCardData
    | GetComparatorEfficientHouse
    | SetComparatorEfficientHouse
    | GetComparatorElectricMobility
    | SetComparatorElectricMobility;
